import {hoistStatics, withProps} from 'recompose'

import type {BasePopupProps, PopupAttrs} from '@jetbrains/ring-ui/components/popup/popup'
import Popup from '@jetbrains/ring-ui/components/popup/popup'
import compose from 'lodash/flowRight'
import type * as React from 'react'

import withEffect from '../../../hocs/withEffect'

import {blockRefresh, unblockRefresh} from './Popup.counter'

export type PopupClass<P extends Partial<BasePopupProps>, S> = React.ComponentClass<P> & S
export function popupEnhancer<P extends Partial<BasePopupProps>, S>(): (
  component: PopupClass<P, S>,
) => PopupClass<P, S> {
  const enhancer = hoistStatics<{}>(
    compose(
      withProps(({trapFocus}: P) => ({
        client: true,
        trapFocus: trapFocus ?? true,
        autoCorrectTopOverflow: false,
      })),
      withEffect(
        (props: P) => props.hidden,
        (hidden: boolean | null | undefined) => {
          if (hidden !== true) {
            blockRefresh()
            return unblockRefresh
          }

          return undefined
        },
      ),
    ),
  )
  return component => enhancer(component) as PopupClass<P, S>
}
export default popupEnhancer<PopupAttrs, typeof Popup>()(
  Popup as PopupClass<PopupAttrs, typeof Popup>,
)
